module.exports = __webpack_public_path__ + "1a718e796057f56e71d2ff09cb375476.MP3";